import React from "react";
import { BiTrash, BiRename, BiArrowBack } from "react-icons/bi";
import { Input } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";

export const BookMarkEdit = ({
    setShowForm,
    handleDeleteBookmark,
    setSelectedBookMark,
    selectedBookmark,
}) => {
    return (
        <>
            <div
                className="bookmark-item"
                key={selectedBookmark.data.createdDate + "Menu_rename_div"}
                onClick={() => setShowForm(true)}>
                <h3>Rename</h3>
                <button className="menu-bookmark">
                    <BiRename />
                </button>
            </div>
            <div
                className="bookmark-item"
                key={selectedBookmark.data.createdDate + "Menu_delete_div"}
                onClick={() => handleDeleteBookmark()}>
                <h3>Delete</h3>
                <button className="menu-bookmark">
                    <BiTrash />
                </button>
            </div>
            <div
                className="bookmark-item"
                key={selectedBookmark.data.createdDate + "Menu_back_div"}
                onClick={() => setSelectedBookMark()}>
                <h3>Back</h3>
                <button className="menu-bookmark">
                    <BiArrowBack />
                </button>
            </div>
        </>
    );
};

export const NameBookMark = ({
    handleCancel,
    changeBookmarkName,
    saveNameCallback,
    isRename,
    validationMessage,
}) => {
    return (
        <div className="bookmark-form">
            <div className="bookmark-input-wrapper">
                <Input
                    className="bookmark-input"
                    name="bookmark"
                    label={"Bookmark name"}
                    onChange={changeBookmarkName}
                />
                {validationMessage && <Error>{validationMessage}</Error>}
            </div>
            <div className="bookmark-actions">
                <Button className="create" onClick={saveNameCallback}>
                    {isRename ? "Rename" : "Create"}
                </Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </div>
        </div>
    );
};
